import { render, staticRenderFns } from "./carv4wardunusual.vue?vue&type=template&id=637c8860&scoped=true&"
import script from "./carv4wardunusual.vue?vue&type=script&lang=js&"
export * from "./carv4wardunusual.vue?vue&type=script&lang=js&"
import style0 from "./carv4wardunusual.vue?vue&type=style&index=0&id=637c8860&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "637c8860",
  null
  
)

export default component.exports